// eslint-disable-next-line filenames/match-exported
import { mobileAppLight, mobileAppDark } from './mobile';
import { pcAppDark, pcAppLight, pcWencaiLight } from './pc';
import { businessTreemapMarketLight } from './business';
import { ainvestAppLight, ainvestAppDark } from './ainvest';

// 主题的颜色模式：黑夜模式和正常模式
export type PresetMode = 'light' | 'dark';

const presetThemes = [
  // MOBILE ------------------------------------------
  mobileAppLight,
  mobileAppDark,
  ainvestAppLight,
  ainvestAppDark,

  // PC ------------------------------------------
  pcAppLight,
  pcAppDark,
  pcWencaiLight,

  // BUSINESS ------------------------------------------
  businessTreemapMarketLight
];

export const PRESET_THEME = {
  // MOBILE ------------------------------------------
  MOBILE_APP_LIGHT: mobileAppLight.name,
  MOBILE_APP_DARK: mobileAppDark.name,
  AINVEST_APP_LIGHT: ainvestAppLight.name,
  AINVEST_APP_DARK: ainvestAppDark.name,

  // PC ------------------------------------------
  PC_APP_LIGHT: pcAppLight.name,
  PC_APP_DARK: pcAppDark.name,
  PC_WENCAI_LIGHT: pcWencaiLight.name,

  // BUSINESS ------------------------------------------
  BUSINESS_TREEMAP_MARKET_LIGHT: businessTreemapMarketLight.name
} as const;

export default presetThemes;
